/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery, coloredScrollBar, convertHexToRGB } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TABLE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	tablewrapper: {
		display: 'flex',
		flexDirection: 'column',
		position: 'relative',

		// no data view
		'& .nodataview': {
			height: pxToEm(301),
			'& .copy': {
				marginTop: pxToEm(-36)
			}
		},

		// ----- pagination ----- //
		'& .pagination': {
			position: 'relative',
			zIndex: '2', //forces this overtop of links in footer
			textAlign: 'center'
		},
		'&.paginationLocation': {
			'&-top': {
				'& .pagination': {
					order: '-1',
					marginBottom: pxToEm(12)
				},
				'&.hasHeader-true': {
					'& .pagination': {
						marginBottom: pxToEm(-20)
					}
				}
			},
			'&-bottom': {
				'& .pagination': {
					order: '1',
					marginTop: pxToEm(12)
				},
				'&.hasFooter-true': {
					'& .pagination': {
						marginTop: pxToEm(-20)
					}
				},
				'&-left': {
					'& .pagination': {
						order: '1',
						marginTop: pxToEm(12)
					},
					'&.hasFooter-true': {
						'& .pagination': {
							marginTop: pxToEm(-20),
							marginLeft: '0',
							marginRight: pxToEm(10)
						}
					}
				}
			}
		},

		// ----- header ----- //
		'& .name-tableheader': {
			marginBottom: pxToEm(12),
			'& .gridset': {
				justifyContent: 'space-between',
				alignItems: 'flex-end',
				alignContent: 'flex-end',
				'& .griditem': {
					'&.name-headertitle': {
						'& .title': {
							position: 'relative',
							zIndex: '1',
							'& *': {
								margin: '0 !important'
							}
						},
					},
					'&.name-headerctas': {
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-end',
						'& .exportexcel': {
							marginRight: pxToEm(20),
							'&:last-child': {
								marginRight: 0
							}
						}
					}
				}
			}
		},

		// ----- message ----- //
		'& .name-tablemessage': {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			textAlign: 'center',

			background: 'rgb(250, 251, 252)',
			border: '1px solid rgb(239, 239, 239)',
			minHeight: pxToEm(222),
			padding: replacePXinStringWithEM(`0px 20px`)
		},

		// ----- footer ----- //
		'& .name-tablefooter': {
			textAlign: 'right',
			paddingTop: pxToEm(16)
		},

		// ----- size ----- //
		'&.size': {
			'&-full': {
				width: '100%',
				// maxWidth: pxToEm(1400),
				'& .tableview': {
					overflowX: 'auto',
					'& .table': {
						width: '100%',
					}
				}
			}
		},



		// (((((((((( ------- VARIANT ---------- )))))))))) //
		// specifically styled tables (almost like themes)
		// ::::: VARIANT - STANDARD ::::: //
		'&.variant-standard': {
			// column //
			'& td': {
				background: theme.color.light.light.swatch,
				borderBottom: `1px solid #eee`,
				padding: replacePXinStringWithEM(`15px`),
				textAlign: 'left'
			},
			// head //
			'& th': {
				background: theme.color.light.light.swatch,
				color: convertHexToRGB(theme.color.supporting.dark.swatch, 50),
				fontSize: pxToEm(16),
				fontWeight: '500',
				padding: replacePXinStringWithEM(`15px`),
				textAlign: 'left'
			},
			// row //
			'& tr': {
				'&.specialrow': {
					'& td': {
						backgroundColor: theme.color.supporting.dark.swatch,
						color: theme.color.light.light.swatch,
						fontWeight: '600'
					}
				},
				'&:hover': {
					'& td': { background: theme.color.secondary.xlight.swatch },
					'&.specialrow': { '& td': { background: theme.color.supporting.dark.swatch, filter: 'brightness(90%)' } }
				},
				'&:nth-child(odd)': { '& td': { background: theme.color.supporting.light.swatch } },
				'&:last-child': { '& td': { borderBottom: '0' } },
				'&:nth-child(1)': { '& td': { borderTop: replacePXinStringWithEM(`2px solid #B7C8E9`) } }
			},
			// table //
			'& .tableview': {
				border: replacePXinStringWithEM(`1px solid #eee`),
				extend: coloredScrollBar("hsla(208, 70%, 80%, 1)"),
				'& table': {
					background: theme.color.light.light.swatch,
					borderCollapse: 'separate', // must be this or we break border lines
					borderSpacing: '0'
				}
			}
		},
		// ::::: VARIANT - SLIM ::::: //
		'&.variant-slim': {
			// column //
			'& td': {
				background: theme.color.light.light.swatch,
				borderBottom: '1px solid rgb(239, 239, 239)',
				borderRight: '1px solid rgb(239, 239, 239)',
				fontSize: pxToEm(13),
				fontWeight: '500',
				padding: replacePXinStringWithEM(`7px 15px`),
				textAlign: 'left'
			},
			// head // 
			'& th': {
				background: 'rgb(250, 251, 252)',
				borderBottom: '1px solid rgb(239, 239, 239)',
				borderRight: '1px solid rgb(239, 239, 239)',
				fontSize: pxToEm(14),
				fontWeight: '500',
				padding: replacePXinStringWithEM(`15px 15px`),
				textAlign: 'left'
			},
			// row //
			'& tr': {
				'&.specialhead': {
					'& th': {
						fontSize: pxToEm(13),
						padding: replacePXinStringWithEM(`7px 15px`)
					}
				},
				'&.specialrow': {
					'& td': {
						backgroundColor: theme.color.supporting.dark.swatch,
						color: theme.color.light.light.swatch,
						fontWeight: '600'
					}
				},
				'&:hover': {
					'& td': { background: theme.color.secondary.xlight.swatch },
					'&.specialrow': { '& td': { background: theme.color.supporting.dark.swatch, filter: 'brightness(90%)' } }
				},
				'&:last-child': { '& td': { borderBottom: '0', borderRight: '0' } },
			},
			// table //
			'& .tableview': {
				border: replacePXinStringWithEM(`1px solid rgb(239, 239, 239)`),
				extend: coloredScrollBar("hsla(208, 70%, 80%, 1)"),
				'& table': {
					background: theme.color.light.light.swatch,
					borderCollapse: 'separate', // must be this or we break border lines
					borderSpacing: '0'
				}
			}
		},
		// ::::: VARIANT - NOWRAP ::::: //
		'&.variant-nowrap': {
			// column //
			'& td': {
				background: theme.color.light.light.swatch,
				borderBottom: `1px solid #eee`,
				padding: replacePXinStringWithEM(`15px`),
				textAlign: 'left',
				textOverflow: 'ellipsis',
				overflow: 'hidden',
				whiteSpace: 'nowrap',
			},
			// head //
			'& th': {
				background: theme.color.light.light.swatch,
				color: convertHexToRGB(theme.color.supporting.dark.swatch, 50),
				fontSize: pxToEm(16),
				fontWeight: '500',
				padding: replacePXinStringWithEM(`15px`),
				textAlign: 'left'
			},
			// row //
			'& tr': {
				'&.specialrow': {
					'& td': {
						backgroundColor: theme.color.supporting.dark.swatch,
						color: theme.color.light.light.swatch,
						fontWeight: '600'
					}
				},
				'&:hover': {
					'& td': { background: theme.color.secondary.xlight.swatch },
					'&.specialrow': { '& td': { background: theme.color.supporting.dark.swatch, filter: 'brightness(90%)' } }
				},
				'&:nth-child(odd)': { '& td': { background: theme.color.supporting.light.swatch } },
				'&:last-child': { '& td': { borderBottom: '0' } },
				'&:nth-child(1)': { '& td': { borderTop: replacePXinStringWithEM(`2px solid #B7C8E9`) } },
			},
			// table //
			'& .tableview': {
				border: replacePXinStringWithEM(`1px solid #eee`),
				extend: coloredScrollBar("hsla(208, 70%, 80%, 1)"),
				'& table': {
					tableLayout: 'fixed',
					background: theme.color.light.light.swatch,
					borderCollapse: 'separate', // must be this or we break border lines
					borderSpacing: '0',
					'& th:nth-child(1)': {
						width: '10%'
					},
					'& th:nth-child(2)': {
						width: '60%'
					},
				}
			}
		},


		// ----- type ----- //
		// !!!! must come after variant for styles to work properly
		'&.type': {
			// fixed first column
			'&-fixed-column': {
				overflow: 'hidden',
				'& .tableview': {
					overflowX: 'auto',
					scrollBehavior: 'smooth',
					'& table': {
						'& th:first-child, td:first-child': {
							borderRight: replacePXinStringWithEM(`2px solid #D7D7D7`),
							position: 'absolute',
							left: pxToEm(1),
							zIndex: '2'
						},
						'& th:first-child': {
							height: '80%'
						},
						'& td:first-child': {
							color: `rgb(114, 161, 232)`
						},
						'& th, td': {
							whiteSpace: 'nowrap'
						},
						'& tr:last-child': {
							'& .grouper': {
								borderBottom: '0'
							}
						},
						'& .grouper': {
							display: 'table-cell',
							width: pxToEm(200), // can be overridden from passed prop to table component
							borderBottom: replacePXinStringWithEM(`1px solid #eee`),
							transition: 'all .2s linear 0s',
							'& .sizer': {
								width: pxToEm(200) // can be overridden from passed prop to table component
							},
							'& .spacer': {
								transition: 'all .2s linear 0s',
								'& .sizer': {
									width: pxToEm(200)
								}
							}
						}
					}
				}
			}
		},

		// ------- loading state ----------//
		'& .loading': {
			'& .name-loader': {
				height: pxToEm(16),
				width: pxToEm(16),
				paddingBottom: pxToEm(20),
				'& div': {
					borderColor: `${theme.color.primary.medium.swatch} transparent transparent transparent`,
					borderWidth: pxToEm(2),
					height: pxToEm(16),
					width: pxToEm(16)
				}
			}
		},

		'&.name-rank': {
			'& tr': {
				'& th:first-child, td:first-child': {
					textAlign: 'center !important'
				}
			}
		}
	},



	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: {
		tablewrapper: {
			'&.paginationLocation-top.hasHeader-true .pagination': {
				marginBottom: pxToEm(10)
			},
			'& .name-tableheader': {
				'& .gridset.direction-horizontal': {
					flexDirection: 'row',
					flexWrap: 'wrap'
				}
			},
			'&.variant-nowrap': {
				'& .tableview': {
					'& table': {
						tableLayout: 'auto'
					}
				}
			}
		}
	}
});